import script from "./CompanyCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyCard.vue?vue&type=script&setup=true&lang=js"

import "./CompanyCard.vue?vue&type=style&index=0&id=3d274abe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d274abe"]])

export default __exports__